function Details() {
  return (
    <div className="mt-10 lg:w-5/6 mx-auto sm:w-full">
      <h1 className="text-primary-text text-2xl font-semibold mb-6">Details</h1>
      <div>
        <p className="text-primary-text text-lg font-semibold">
          Why am I not eligible?
        </p>
        <p className="text-secondary-text mt-2">
          To join the competition, you must have applied before the deadline.
          Please check your email inbox and spam folder for confirmation from
          community@vertexprotocol.com and follow the instructions to
          participate.
          <br />
          <br />
          To access the app, check the link sent in the confirmation email. If you don't see it, please check your spam folder.
        </p>
      </div>
      <div className="mt-6">
        <p className="text-primary-text text-lg font-semibold">
          What are the rules?
        </p>
        <p className="text-secondary-text mt-2">
          To qualify for the trading competition, a trader needs to have a
          minimum total deposit of $250. There is no maximum total deposit. The
          winners of the competition will be based on the top 5 best PnL % after
          one week.
          <br />
          <br />
          Traders from Vertex’s restricted jurisdictions, including the United
          States, won’t be allowed to participate or use the Vertex frontend.
        </p>
      </div>
      <div className="mt-6">
        <p className="text-primary-text text-lg font-semibold">
          What are the prizes?
        </p>
        <p className="text-secondary-text mt-2">
          The top 5 traders will recieve:
        </p>
        <ul className="list-disc ml-5">
          <li className="text-secondary-text">1st - $15k</li>
          <li className="text-secondary-text">2nd - $5k</li>
          <li className="text-secondary-text">3rd - $3k</li>
          <li className="text-secondary-text">4th - $1.5k</li>
          <li className="text-secondary-text">5th - $500</li>
        </ul>
        <p className="text-secondary-text mt-1">Paid in USDC.</p>
      </div>
      <div className="mt-6">
        <p className="text-primary-text text-lg font-semibold">
          What is the duration?
        </p>
        <p className="text-secondary-text mt-2">
          Start: Monday, April 10th at 12:01 AM UTC
          <br />
          End: Sunday, April 16th at 11:59 PM UTC
        </p>
      </div>
      <div className="mt-6">
        <p className="text-primary-text text-lg font-semibold">
          How is PnL calculated?
        </p>
        <p className="text-secondary-text mt-2">
          % pnl on timeframe = (pnl in dollar terms on timeframe) / (starting
          account value + total dollar value of deposits on timeframe).
        </p>
      </div>
      <div className="mt-6">
        <p className="text-primary-text text-lg font-semibold">
          What happens if I withdraw my deposits?
        </p>
        <p className="text-secondary-text mt-2">
          Withdrawing doesn't decrease your total deposits and if you withdraw
          during the competition it could negatively impact your PnL %.
        </p>
      </div>
    </div>
  );
}

export default Details;
